import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Instagram } from "lucide-react";
import { Logo } from "@/components/brand/Logo";

export default function MarketingFooter() {
  return (
    <footer className="bg-[var(--lh-black)] text-white" data-testid="marketing-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo light />
            <p className="mt-6 text-sm text-white/70 max-w-md leading-relaxed">
              Marketing education, growth tools, and a community built to help women-owned businesses become the go-to brands in their cities.
            </p>
          </div>
          <div className="md:col-span-2">
            <div className="overline text-[var(--lh-mauve)] mb-5">Platform</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li><a href="#membership" className="hover:text-[var(--lh-mauve)]">Membership</a></li>
              <li><Link to="/her-guide" className="hover:text-[var(--lh-mauve)]">HER Guide</Link></li>
              <li><Link to="/blog" className="hover:text-[var(--lh-mauve)]">The Journal</Link></li>
              <li><a href="#events" className="hover:text-[var(--lh-mauve)]">Events</a></li>
              <li><a href="#resources" className="hover:text-[var(--lh-mauve)]">Resources</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="overline text-[var(--lh-mauve)] mb-5">Cities</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li>Phoenix</li>
              <li>Scottsdale</li>
              <li>Gilbert</li>
              <li>Coming soon</li>
            </ul>
            <div className="overline text-[var(--lh-mauve)] mt-8 mb-5">Legal</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li><Link to="/guidelines" className="hover:text-[var(--lh-mauve)]" data-testid="footer-guidelines">Community Guidelines</Link></li>
              <li><Link to="/terms" className="hover:text-[var(--lh-mauve)]" data-testid="footer-terms">Terms</Link></li>
              <li><Link to="/privacy" className="hover:text-[var(--lh-mauve)]" data-testid="footer-privacy">Privacy</Link></li>
              <li><Link to="/accessibility" className="hover:text-[var(--lh-mauve)]" data-testid="footer-accessibility">Accessibility</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="overline text-[var(--lh-mauve)] mb-5">Contact</div>
            <p className="text-sm text-white/80 leading-relaxed">
              hello@localizeher.com<br />
              Press · Partnerships · Press
            </p>
            <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
              <a
                href="https://www.linkedin.com/company/localizeher"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LocalizeHER on LinkedIn"
                className="w-10 h-10 inline-flex items-center justify-center rounded-full border border-white/20 text-white/80 hover:text-[var(--lh-espresso)] hover:bg-[var(--lh-peach)] hover:border-[var(--lh-peach)] transition-colors"
                data-testid="footer-linkedin"
              >
                <Linkedin size={16} strokeWidth={1.75} />
              </a>
              <a
                href="https://instagram.com/localizeher"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LocalizeHER on Instagram"
                className="w-10 h-10 inline-flex items-center justify-center rounded-full border border-white/20 text-white/80 hover:text-[var(--lh-espresso)] hover:bg-[var(--lh-peach)] hover:border-[var(--lh-peach)] transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={16} strokeWidth={1.75} />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50 overline">
          <span>© 2026 LocalizeHER. Made with intention.</span>
          <div className="flex gap-5">
            <Link to="/terms" className="hover:text-white/80">Terms</Link>
            <Link to="/privacy" className="hover:text-white/80">Privacy</Link>
            <Link to="/accessibility" className="hover:text-white/80">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
